import type { CustomFetchOptions, Method } from '@luna/api';
import { request } from '@luna/api';
import { getToken } from '@shared/auth';
import { blobToBase64 } from '@luna/utils';

const ACCESS_TOKEN = 'access_token';
const URL_ENCODED_CONTENT_TYPE = 'application/x-www-form-urlencoded';

export const getUrlEncodedAccessToken = (token: string): string => {
    return [ACCESS_TOKEN, encodeURIComponent(token)].join('=');
};

export const getFetchByteImageOptions = (method: Method): CustomFetchOptions => {
    if (method !== 'POST') {
        return {};
    }

    return {
        body: getUrlEncodedAccessToken(getToken()),
        headers: {
            'Content-Type': URL_ENCODED_CONTENT_TYPE,
        },
    };
};

export const getHeaders = (sendAcceptHeader: boolean): Record<string, string> | undefined => {
    if (!sendAcceptHeader) {
        return undefined;
    }

    return { Accept: 'image/png' };
};

export async function fetchByteImage(
    url: string,
    sendAcceptHeader: boolean,
    method: Method,
): Promise<string> {
    try {
        const data = await request(url, {
            ...getFetchByteImageOptions(method),
            method,
            skipParseJSON: true,
            headers: getHeaders(sendAcceptHeader),
        });

        return blobToBase64(await data.blob());
    } catch {
        return '';
    }
}
